import React, { useState } from 'react';
import { Search, Heart, User, ShoppingBag, Menu, X, ChevronDown, Phone, Mail } from 'lucide-react';
import { navigation } from '../data/mockData';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <header className="w-full">
      {/* Announcement Bar */}
      <div className="bg-[#1a365d] text-white text-center py-2.5 text-sm tracking-wide">
        <a href="#" className="hover:underline">
          Book a consultation with one of our design experts!
        </a>
      </div>

      {/* Top Bar - Desktop */}
      <div className="hidden lg:flex items-center justify-between px-8 py-3 border-b border-gray-100">
        {/* Left - Social & Contact */}
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-3">
            <a href="#" className="text-[#1a365d] hover:opacity-70 transition-opacity">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </a>
            <a href="#" className="text-[#1a365d] hover:opacity-70 transition-opacity">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
            </a>
            <a href="#" className="text-[#1a365d] hover:opacity-70 transition-opacity">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.757-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/></svg>
            </a>
            <a href="#" className="text-[#1a365d] hover:opacity-70 transition-opacity">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z"/></svg>
            </a>
            <a href="#" className="text-[#1a365d] hover:opacity-70 transition-opacity">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
            </a>
            <a href="#" className="text-[#1a365d] hover:opacity-70 transition-opacity">
              <Mail className="w-4 h-4" />
            </a>
          </div>
          <div className="flex items-center gap-4 text-sm text-[#1a365d] ml-4">
            <a href="tel:214-952-0001" className="flex items-center gap-1.5 hover:opacity-70 transition-opacity">
              214-952-0001
            </a>
            <a href="mailto:Dqkyukim@gmail.com" className="hover:opacity-70 transition-opacity">
              Dqkyukim@gmail.com
            </a>
          </div>
        </div>

        {/* Right - Search, Currency, Icons */}
        <div className="flex items-center gap-6">
          <div className="relative">
            <input
              type="text"
              placeholder="Search"
              className="w-48 py-1.5 px-3 pr-8 border border-gray-200 rounded text-sm focus:outline-none focus:border-[#1a365d]"
            />
            <Search className="w-4 h-4 absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400" />
          </div>
          <div className="flex items-center gap-1 text-sm text-[#1a365d]">
            <span>United States (USD $)</span>
            <ChevronDown className="w-4 h-4" />
          </div>
          <div className="flex items-center gap-4">
            <button className="text-[#1a365d] hover:opacity-70 transition-opacity">
              <Heart className="w-5 h-5" />
            </button>
            <button className="text-[#1a365d] hover:opacity-70 transition-opacity">
              <User className="w-5 h-5" />
            </button>
            <button className="text-[#1a365d] hover:opacity-70 transition-opacity flex items-center gap-1">
              <ShoppingBag className="w-5 h-5" />
              <span className="text-sm">0</span>
            </button>
          </div>
        </div>
      </div>

      {/* Logo & Navigation - Desktop */}
      <div className="hidden lg:block">
        {/* Logo */}
        <div className="flex justify-center py-4">
          <a href="/" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full border-2 border-[#1a365d] flex items-center justify-center">
              <svg className="w-4 h-4 text-[#1a365d]" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
              </svg>
            </div>
            <span className="text-2xl font-light tracking-[0.2em] text-[#1a365d]">DIAMOND Q JEWELERS</span>
          </a>
        </div>

        {/* Navigation */}
        <nav className="flex justify-center gap-8 py-3 border-t border-gray-100">
          {navigation.mainNav.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="flex items-center gap-1 text-sm text-[#1a365d] hover:opacity-70 transition-opacity tracking-wide"
            >
              {item.name}
              {item.hasDropdown && <ChevronDown className="w-3 h-3" />}
            </a>
          ))}
        </nav>
      </div>

      {/* Mobile Header */}
      <div className="lg:hidden flex items-center justify-between px-4 py-3">
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="text-[#1a365d] p-1"
        >
          {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>

        <a href="/" className="flex items-center gap-2">
          <div className="w-6 h-6 rounded-full border-2 border-[#1a365d] flex items-center justify-center">
            <svg className="w-3 h-3 text-[#1a365d]" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
            </svg>
          </div>
          <span className="text-lg font-light tracking-[0.15em] text-[#1a365d]">DIAMOND Q JEWELERS</span>
        </a>

        <div className="flex items-center gap-3">
          <button onClick={() => setSearchOpen(!searchOpen)} className="text-[#1a365d]">
            <Search className="w-5 h-5" />
          </button>
          <button className="text-[#1a365d] flex items-center gap-1">
            <ShoppingBag className="w-5 h-5" />
            <span className="text-sm">0</span>
          </button>
        </div>
      </div>

      {/* Mobile Search */}
      {searchOpen && (
        <div className="lg:hidden px-4 pb-3">
          <div className="relative">
            <input
              type="text"
              placeholder="Search"
              className="w-full py-2 px-3 pr-8 border border-gray-200 rounded text-sm focus:outline-none focus:border-[#1a365d]"
            />
            <Search className="w-4 h-4 absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
          </div>
        </div>
      )}

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100">
          <nav className="px-4 py-4 space-y-4">
            {navigation.mainNav.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="flex items-center justify-between text-[#1a365d] py-2 border-b border-gray-100"
              >
                {item.name}
                {item.hasDropdown && <ChevronDown className="w-4 h-4" />}
              </a>
            ))}
          </nav>
          <div className="px-4 py-4 border-t border-gray-100 flex items-center gap-4">
            <a href="#" className="text-[#1a365d]">
              <Heart className="w-5 h-5" />
            </a>
            <a href="#" className="text-[#1a365d]">
              <User className="w-5 h-5" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
